(($) => {
  // Setup a timer
  let timeout;

  function fiftyFiftyTablet() {
    $('.band-50-50-overlap').each(() => {
      const fiftyBody = $('.overlap-body', this).height();
      const fiftyImage = $('.overlap-image', this).height();

      if (fiftyBody > fiftyImage) {
        $('.overlap-wrapper', this).css({
          height: fiftyBody,
          'align-items': 'center',
        });
      } else {
        $('.overlap-wrapper', this).css({
          height: 'auto',
          'align-items': 'center',
        });
      }
    });
  }

  function fiftyFiftyMobile() {
    $('.band-50-50-overlap').each(() => {
      $('.overlap-wrapper', this).css({
        height: 'auto',
        'align-items': 'initial',
      });
    });
  }

  // Listen for DOM Ready events.
  document.addEventListener(
    'DOMContentLoaded',
    () => {
      if ($(window).width() > 768) {
        fiftyFiftyTablet();
      } else {
        fiftyFiftyMobile();
      }
    },
    false,
  );

  // Listen for resize events.
  window.addEventListener(
    'resize',
    () => {
      // If there's a timer, cancel it
      if (timeout) {
        window.cancelAnimationFrame(timeout);
      }

      // Setup the new requestAnimationFrame()
      timeout = window.requestAnimationFrame(() => {
        if ($(window).width() > 768) {
          fiftyFiftyTablet();
        } else {
          fiftyFiftyMobile();
        }
      });
    },
    false,
  );
})(jQuery);
